import { ModelBase } from "@singularsystems/neo-core";

export default class APIModelBase extends ModelBase {

    // Client only properties / methods
}